import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import NavAppBar from "../components/navAppBar";
import { Box, Menu, MenuItem } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "../config";
import styled from "styled-components";
import DisplaySection from "../components/displaySection";
import AddIcon from "@mui/icons-material/Add";
import BannerReferral from "../components/bannerReferral";

const BannerBox = styled.div`
  background: rgb(234, 235, 242);
`

const MiyaRecordSection = styled.div`
  margin: 0 10%;
  padding: 1rem;
  flex: 1 1 48%;
  border-radius: 4px;
  min-height: 50px;
  margin-top: 1rem;
  background-color: #fff;
  & .detail {
    display: flex;
    flex-flow: row wrap;
    align-items: flex-start;
    align-content: flex-start;
  }
  & .info {
    flex: 0 1 200px;
    margin-bottom: 10px;
    font-size: 14px;
  }
  & .info dl dt {
    margin-bottom: 2px;
    color: #828282;
    margin: 0;
    padding: 0;
    font-weight: 400;
    line-height: normal;
  }
  & .info dl dd {
margin: 0;
    padding: 0;
    font-weight: 400;
    line-height: normal;
    }
`;
const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  height: 17.5938px;
  line-height: 17.6px;
  color: rgb(0, 0, 0);
  display: block;
  font-family: "Source Sans Pro", sans-serif;
`;

const labelMapping = {
  patient_information: {
    internalpatientid: "Internal Patient ID",
    episodenumber: "Episode Number",
    originaldateonlist: "Original Date on List",
    currentdateonlist: "Current Date on List",
    entrystatuscode: "Entry Status Code",
    entrystatusdescription: "Entry Status Description",
  },
  appointment_details: {
    appointmentprioritycode: "Appointment Priority Code",
    appointmentprioritydescription: "Appointment Priority Description",
    consultant: "Consultant",
    specialty: "Specialty",
    clinic: "Clinic",
    clinicgroup: "Clinic Group",
    locationtype: "Location Type",
    location: "Location",
    owninghospital: "Owning Hospital",
    expectedbookingsystemcode: "Expected Booking System Code",
    ebsdescription: "EBS Description",
    estimatedcontactdate: "Estimated Contact Date",
    appointmentprocedure: "Appointment Procedure",
  },
  referral_information: {
    referralnumber: "Referral Number",
    opepisodenumber: "OP Episode Number",
    opappointmentnumber: "OP Appointment Number",
    completeddate: "Completed Date",
    removaldate: "Removal Date",
    removalreasoncode: "Removal Reason Code",
    removalreasondescription: "Removal Reason Description",
    removaltextcomment: "Removal Text Comment",
  },
  provider_and_commissioner: {
    providercode: "Provider Code",
    commissionercode: "Commissioner Code",
    slacodeid: "SLA Code ID",
    contractreference: "Contract Reference",
  },
  review_and_status: {
    reviewindicator: "Review Indicator",
    lastreviewsequence: "Last Review Sequence",
    reviewdate: "Review Date",
    shortcallavailabilityindicator: "Short Call Availability Indicator",
    noticerequired: "Notice Required",
    transportrequired: "Transport Required",
    trasnferfromclinic: "Transfer From Clinic",
    transferfromconsultant: "Transfer From Consultant",
    transferfromspecialty: "Transfer From Specialty",
    transferfromdate: "Transfer From Date",
    pendingstatus: "Pending Status",
    currentsequence: "Current Sequence",
  },
  hddr_and_comments: {
    hddr_group: "HDDR Group",
    freetextcomments: "Free Text Comments",
  },
  patient_category_and_appointment_flags: {
    patientcategorycode: "Patient Category Code",
    patientcategorydescription: "Patient Category Description",
    appointmentslottypecode: "Appointment Slot Type Code",
    appointmentslottypedescription: "Appointment Slot Type Description",
    coronavirusprioritycode: "Coronavirus Priority Code",
    coronaviruscategorycode: "Coronavirus Category Code",
    coronavirussubcategorycode: "Coronavirus Subcategory Code",
    cornonavirusdate: "Coronavirus Date",
    plannedappointmentflagcode: "Planned Appointment Flag Code",
    plannedappointmentflagdescription: "Planned Appointment Flag Description",
    plannedappointmentdate: "Planned Appointment Date",
    plannedappointmentnotes: "Planned Appointment Notes",
  },
};

const RttPatientDetails = () => {
  const [waitlistItem, setWaitlistItem] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = React.useState(null);
  const navigate = useNavigate();
  const { patientId, referralId, rttId } = useParams();
  const cfg = global.config.restAPI; //"http://localhost:3000/";

  useEffect(() => {
    // Fetch referral details based on the ID from the URL params
    const query = {
      internalpatientid: { $eq: patientId },
      referralnumber: { $eq: referralId },
      pathwayid: { $eq: rttId },
    };
    axios
      .get(
        `${cfg.url + cfg.endpoints.rtt}/?q=${JSON.stringify(query)}`,
      )
      .then((response) => {
        const firstItem = response.data.items[0];
        setWaitlistItem(firstItem);
      });
  }, [patientId, referralId, rttId, cfg]);

  if (!waitlistItem) {
    return <p style={{ marginLeft: 24 }}>Loading...</p>;
  }

  const menuOpen = Boolean(menuAnchorEl);

  const handleMenuClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };
  const handleMenuClose = (e) => {
    setMenuAnchorEl(null);
    switch (e.currentTarget.innerText) {
      case "Appointment List":
        navigate(`/clinic/patient/${patientId}/referral/${referralId}/appointment/`)
        break;
      case "Waitlist Management":
        navigate(`/waitlist/patient/${patientId}/referral/${referralId}/waitlist/`)
        break;
      case "RTT pathway":
        navigate(`../patient/${patientId}/referral/${referralId}/rtt/`)
        break;
      default:
        return
    }
  };

  return (
    <div style={{ background: "#eaebf2", flex: 1 }}>
      <NavAppBar title="RTT Pathway Details">
        <Button
          type="primary"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() =>
            navigate(
              `/clinic/patient/${patientId}/referral/${referralId}/appointment/create`,
            )
          }
        >
          Appointment
        </Button>
        <Button variant="outlined" style={{ marginLeft: 10 }}
          onClick={handleMenuClick}
        >
          More
        </Button>
        <Menu anchorEl={menuAnchorEl} open={menuOpen} onClose={handleMenuClose}>
          <MenuItem onClick={handleMenuClose}>Modify RTT Pathway</MenuItem>
          <MenuItem onClick={handleMenuClose}>Manage notes</MenuItem>
          <MenuItem onClick={handleMenuClose}>View referral</MenuItem>
          <MenuItem onClick={handleMenuClose}>Schedule appointment</MenuItem>
          <MenuItem onClick={handleMenuClose}>Patient communications</MenuItem>
          <MenuItem onClick={handleMenuClose}>Appointment List</MenuItem>
          <MenuItem onClick={handleMenuClose}>Waitlist Management</MenuItem>
        </Menu>
      </NavAppBar>

      <BannerBox>
        <BannerReferral referralId={referralId} patientId={patientId} onSelect={() => navigate(`/referral/patient/${patientId}/referral/${referralId}`)} />
      </BannerBox>

      <DisplaySection
        title="Patient Information"
        labelMap={labelMapping.patient_information}
        data={waitlistItem}
      />
      <DisplaySection
        title="Waitlist Details"
        labelMap={labelMapping.referral_information}
        data={waitlistItem}
      />
      <DisplaySection
        title="Appointment Details"
        labelMap={labelMapping.appointment_details}
        data={waitlistItem}
      />
      <DisplaySection
        title="Flags and Other Details"
        labelMap={labelMapping.patient_category_and_appointment_flags}
        data={waitlistItem}
      />
    </div>
  );
};

export default RttPatientDetails;
